import type { UseMutationOptions } from '@tanstack/react-query';
import { mutationOptions } from '@tanstack/react-query';

import { BRAND_SERVICE_VERSION_HEADERS } from '@/constants/environments';
import apiClient from '@/constants/http';

import type {
  UpdateWaitlistTipRequest,
  UpdateWaitlistTipResponse,
} from './types';

async function updateWaitlistTip(
  request: UpdateWaitlistTipRequest,
): Promise<UpdateWaitlistTipResponse> {
  const { data } = await apiClient.put<UpdateWaitlistTipResponse>(
    `/v1/customer/waiting-list/${request.waitlistCustomerId}`,
    { tipAmount: request.tipAmount },
    {
      headers: BRAND_SERVICE_VERSION_HEADERS,
    },
  );

  return data;
}

export const updateWaitlistTipMutation = (
  options?: UseMutationOptions<
    UpdateWaitlistTipResponse,
    Error,
    UpdateWaitlistTipRequest
  >,
) =>
  mutationOptions({
    ...options,
    retry: false,
    mutationKey: ['updateWaitlistTip'],
    mutationFn: (request: UpdateWaitlistTipRequest) =>
      updateWaitlistTip(request),
  });
